var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeviceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.53 27.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Naprave") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ikone"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ikone-2",
    "data-name": "ikone"
  }, /*#__PURE__*/React.createElement("line", {
    id: "line11",
    className: "cls-1",
    x1: 8.06,
    y1: 3.33,
    x2: 23.35,
    y2: 3.33
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle13",
    className: "cls-1",
    cx: 5.73,
    cy: 3.33,
    r: 2.33
  }), /*#__PURE__*/React.createElement("line", {
    id: "line15",
    className: "cls-1",
    y1: 3.33,
    x2: 3.4,
    y2: 3.33
  }), /*#__PURE__*/React.createElement("line", {
    id: "line17",
    className: "cls-1",
    x1: 15.48,
    y1: 13.9,
    x2: 0.18,
    y2: 13.9
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle19",
    className: "cls-1",
    cx: 17.8,
    cy: 13.9,
    r: 2.33
  }), /*#__PURE__*/React.createElement("line", {
    id: "line21",
    className: "cls-1",
    x1: 23.53,
    y1: 13.9,
    x2: 20.13,
    y2: 13.9
  }), /*#__PURE__*/React.createElement("line", {
    id: "line23",
    className: "cls-1",
    x1: 8.12,
    y1: 24.48,
    x2: 23.41,
    y2: 24.48
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle25",
    className: "cls-1",
    cx: 5.79,
    cy: 24.48,
    r: 2.33
  }), /*#__PURE__*/React.createElement("line", {
    id: "line27",
    className: "cls-1",
    x1: 0.06,
    y1: 24.48,
    x2: 3.46,
    y2: 24.48
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceIcon);
export default __webpack_public_path__ + "static/media/deviceIcon.2145eff1ead7bcfb4fc942ce5103eaf1.svg";
export { ForwardRef as ReactComponent };